import dayjs from '~/timeInit';

import { daysOfWeek } from '~/utils/daysOfWeek';

export type DateRangeAvailability = 'live' | 'upcoming' | 'expired' | 'inactive-today' | 'invalid';

export interface DateRangeAvailabilityInput {
  start_date: string;
  end_date: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export function getDateRangeAvailability(input: DateRangeAvailabilityInput, now = dayjs.tz()): DateRangeAvailability {
  const startDate = dayjs.utc(input.start_date);
  const endDate = dayjs.utc(input.end_date);

  if (!startDate.isValid() || !endDate.isValid()) {
    return 'invalid';
  }

  const today = now.format('YYYY-MM-DD');
  const start = startDate.format('YYYY-MM-DD');
  const end = endDate.format('YYYY-MM-DD');

  if (today < start) {
    return 'upcoming';
  }

  if (today > end) {
    return 'expired';
  }

  const currentDay = daysOfWeek.find((day) => day.fullName === now.format('dddd'));
  return currentDay && input[currentDay.key] ? 'live' : 'inactive-today';
}
